import React from "react";
import { Control } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { EmployeeFormValues } from "../schemas/employeeFormSchema";

interface UserNotesFormProps {
  control: Control<EmployeeFormValues>;
}

export const UserNotesForm = ({ control }: UserNotesFormProps) => {
  return (
    <div className="p-6 border-b">
      <h3 className="text-lg font-semibold mb-4">User Notes</h3>
      <div className="space-y-4">
        <FormField
          control={control}
          name="userNotes"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Additional Notes</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Enter any additional notes or comments about this employee..."
                  className="min-h-[120px]"
                  {...field}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
